module.exports = __webpack_public_path__ + "static/media/13_4.6c7e04a6.png";